const coachesNotesParts = ["Ideal Work Day Roadmapper"]

export default coachesNotesParts
